export const FETCH_TRENDING_REQUEST = 'FETCH_TRENDING_REQUEST'
export const FETCH_TRENDING_ERROR = 'FETCH_TRENDING_ERROR'
export const FETCH_TRENDING_SUCCESS = 'FETCH_TRENDING_SUCCESS'

export const fetchTrendingRequest = () => {
    return { type: FETCH_TRENDING_REQUEST }
}



// WEBPACK FOOTER //
// ./src/actions/trending.js